<script lang="ts">
    import {Component, toNative} from 'vue-facing-decorator'
    import __Orders, {Orders as _Orders} from '~/components/account/Orders.vue'

    @Component({mixins: [__Orders]})
    export class Orders extends _Orders {
        // ZSH Customization: Override groupedOrder method to hide IN_PROGRESS status text in order group header
        groupedOrder({value: orderId}: any) {
            // Call the parent groupedOrder method to get the base order object
            const order = super.groupedOrder({value: orderId})

            // Hide status text if the order status is IN_PROGRESS
            if (order.status === 'IN_PROGRESS') {
                return {
                    ...order,
                    statusText: '',
                    statusColor: '',
                }
            }

            return order
        }

        // ZSH Customization: Override services computed property to hide IN_PROGRESS status text
        get services() {
            // Get the base services array by calling the parent getter
            const servicesArray = super.services

            // Hide status text for all items with IN_PROGRESS status
            // This includes service rows, order package rows, and empty order rows
            const result = servicesArray.map(service => {
                // For service rows, statusOriginal contains the raw status (e.g., "IN_PROGRESS")
                // For package/order rows, we need to check the translated status text
                // since statusOriginal is not set for those rows

                // Check if statusOriginal is IN_PROGRESS (for service rows)
                if (service.statusOriginal === 'IN_PROGRESS') {
                    return Object.freeze({
                        ...service,
                        status: '',
                        statusColor: '',
                    })
                }

                // For rows without statusOriginal (package/order rows), check the translated status
                // The translated "In progress" text comes from the i18n key 'bookingStatus.IN_PROGRESS'
                // We need to check if the status text matches the translated "In progress" text
                if (!service.statusOriginal && service.status) {
                    // Get the translated "In progress" text
                    const inProgressText = this.$t('bookingStatus.IN_PROGRESS')
                    if (service.status === inProgressText) {
                        return Object.freeze({
                            ...service,
                            status: '',
                            statusColor: '',
                        })
                    }
                }

                // Return the original service unchanged for all other statuses
                return service
            })

            return result
        }
    }

    export default {...toNative(Orders), ssrRender: __Orders.ssrRender}
</script>
